'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by sbardian on 5/12/17.
 */

var OK = exports.OK = {
  status: 0,
  message: 'Success.'
};

var NO_RESULTS = exports.NO_RESULTS = {
  status: 1,
  message: 'Your query return no results.'
};

var INVALID_PARAMETER = exports.INVALID_PARAMETER = {
  status: 2,
  message: 'Could not return results. The API does not have enough questions for your query. (Ex. Asking for 50 Questions in a Category that only has 20.)'
};

var TOKEN_NOT_FOUND = exports.TOKEN_NOT_FOUND = {
  status: 3,
  message: 'Session Token does not exist.'
};

var TOKEN_EMPTY = exports.TOKEN_EMPTY = {
  status: 4,
  message: 'Session Token has returned all possible questions for the specified query. Resetting the Token is necessary.'
};

var DEFAULT_ERROR = exports.DEFAULT_ERROR = {
  response_code: 6,
  message: 'An unknown response_code error was return from the API.'
};


//////////////////
// WEBPACK FOOTER
// /Users/sbardian/WebstormProjects/Reactjs/opentrivia-react/~/opentriviaapi/lib/responses.js
// module id = 208
// module chunks = 0